import { defineComponent, ref, computed, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useSmartBack } from '@/composables/use-smart-back'
import {
  NavBar as VanNavBar,
  Icon as VanIcon,
  Sticky as VanSticky,
  Search as VanSearch,
  Empty as VanEmpty,
} from 'vant'
import { getApiV1ArticleTypeSearch } from '@/api/sdk.gen'
import { renderArticleList } from '@/components/article-list-view'
import type { Article } from '@/api/types.gen'

const PAGE_SIZE = 15

export default defineComponent({
  name: 'ArticleSearchPage',
  setup() {
    const router = useRouter()
  const goBack = useSmartBack()
    const route = useRoute()

    const typeId = computed(() => Number(route.query.typeId) || 0)
    const lotteryType = computed(() => {
      const v = Number(route.query.lotteryType)
      return v === 1 || v === 2 ? v : undefined
    })
    const title = computed(() => String(route.query.webtitle ?? '论坛搜索'))

    const value = ref('')
    const list = ref<Article[]>([])
    const pageNum = ref(1)
    const finished = ref(false)
    const loading = ref(false)
    const refreshing = ref(false)
    const error = ref(false)

    async function init(mode?: 'refresh') {
      if (!value.value.trim()) return
      loading.value = true
      error.value = false
      try {
        const res = await getApiV1ArticleTypeSearch({
          query: {
            typeId: typeId.value,
            title: value.value.trim(),
            page: pageNum.value,
            size: PAGE_SIZE,
            lotteryType: lotteryType.value,
          },
        })
        const data = res.data?.data
        const items = data?.list ?? []
        list.value = mode === 'refresh' ? items : [...list.value, ...items]
        finished.value = items.length < PAGE_SIZE
      } catch {
        error.value = true
      } finally {
        loading.value = false
        refreshing.value = false
      }
    }

    function onLoad() {
      pageNum.value++
      init()
    }

    function onRefresh() {
      pageNum.value = 1
      init('refresh')
    }

    function onSearch() {
      list.value = []
      pageNum.value = 1
      finished.value = false
      init('refresh')
    }

    onMounted(() => {
      // 初始不请求，等用户输入搜索
    })

    return () => (
      <div class="search-wrap">
        <VanSticky>
          <VanNavBar title={title.value} onClickLeft={() => goBack()}>
            {{
              left: () => <VanIcon name="arrow-left" color="#333" size="16" />,
            }}
          </VanNavBar>
        </VanSticky>

        <div class="search-hd">
          <VanSearch
            v-model={value.value}
            placeholder="请输入您想要的内容"
            showAction
            shape="round"
            background="#fff"
            onSearch={onSearch}
          >
            {{
              action: () => (
                <button type="button" class="search-btn btn-reset" onClick={onSearch}>
                  搜索
                </button>
              ),
            }}
          </VanSearch>
        </div>

        {renderArticleList({
          router,
          list: list.value,
          refreshing,
          loading,
          error,
          finished: finished.value,
          onRefresh,
          onLoad,
          prepend: list.value.length === 0 && !loading.value && (
            <VanEmpty
              image="https://img01.yzcdn.cn/vant/empty-image-default.png"
              description="输入标题或作者关键词以查找"
            />
          ),
        })}
      </div>
    )
  },
})
